import CryptoJS from 'crypto-js';

// In a real application, this key would be stored securely and not in the code
const ENCRYPTION_KEY = 'InstallTrackPro-SecureEncryptionKey-2025';

/**
 * Encrypt data using AES encryption
 */
export const encryptData = (data: string): string => {
  try {
    return CryptoJS.AES.encrypt(data, ENCRYPTION_KEY).toString();
  } catch (error) {
    console.error('Encryption error:', error);
    throw error;
  }
};

/**
 * Decrypt data using AES encryption
 */
export const decryptData = (encryptedData: string): string => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, ENCRYPTION_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error('Decryption error:', error);
    throw error;
  }
};

/**
 * Hash a password using SHA-256
 */
export const hashPassword = (password: string): string => {
  try {
    return CryptoJS.SHA256(password).toString();
  } catch (error) {
    console.error('Password hashing error:', error);
    throw error;
  }
};

/**
 * Verify a password against a hash
 */
export const verifyPassword = (password: string, hash: string): boolean => {
  try {
    const passwordHash = CryptoJS.SHA256(password).toString();
    return passwordHash === hash;
  } catch (error) {
    console.error('Password verification error:', error);
    return false;
  }
};